import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Reusable component for Site ID input
 * @param {Object} props - Component properties
 * @param {string} props.value - Current value of the input
 * @param {Function} props.onChange - Function to handle input changes
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.helpText - Help text displayed below the input
 */
const SiteIdInput = ({
    value,
    onChange,
    placeholder = 'E.g., dealer001, dealer002',
    helpText = 'Separate multiple site IDs with commas or new lines. Site Indexing is limited to 10 sites per Manual Request.',
}) => {
    return (
        <div className="mb-3">
            <Form.Control
                id="siteIds"
                as="textarea"
                rows={3}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="min-h-24"
            />
            <p className="text-xs text-muted-foreground mt-1 text-left">
                {helpText}
            </p>
        </div>
    );
};

export default SiteIdInput;
